export default __webpack_public_path__ + "static/media/img-04.ee453b8e.png";